import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import EnrollmentLinkCreator from './../../components/Admin/EnrollmentLinkCreator.component'
import PageHeading from './../../components/shared/PageHeading.component'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'

import './EnrollmentLinkCreator.page.scss'

class EnrollmentLinkCreatorPage extends Component {
  render() {
    return (
      <Fragment>
        <DashboardLayout>
          <main id='EnrollmentLinkCreatorPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-4'>
              <PageHeading
                label='Enrollment Link Creator'
                url={this.props?.match?.url}
                from={this.props?.location?.state?.from}
              />
            </MDBContainer>
            <MDBContainer>
              <MDBRow>
                <MDBCol size='12'>
                  <EnrollmentLinkCreator />
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default EnrollmentLinkCreatorPage
